/**
 * Tier1Dialogues - Initial Encounter Dialogue Scripts
 * 
 * Dark Forest Portfolio Game
 * Pure data dictionary containing first-meeting dialogue lines for all 5 NPCs.
 * Displayed when the player first converses with an NPC prior to world exploration.
 */

export const Tier1Dialogues = Object.freeze({
  mentor: Object.freeze([
    "Welcome, developer. I see you've arrived in this dark forest.",
    "I've been waiting. Your journey begins now.",
    "Three paths lie ahead of you. Each holds lessons.",
    "Web development will show you how to build for the world.",
    "Data science will teach you to read the patterns hidden in everything.",
    "Mobile development will show you how to create experiences people carry with them.",
    "Explore. Learn. Return to the summit when you understand your full potential."
  ]),

  fullstack: Object.freeze([
    "Ah, a fellow builder. Welcome to the Web Dev Outpost.",
    "I see you're curious about full-stack development.",
    "EduVault is my pride—a complete learning management system.",
    "REST APIs, Firebase backends, semantic similarity grading. The full stack.",
    "CodeXcape is where development meets creativity. A two-player escape room built for learning.",
    "Not everyone combines technical depth with fun. But you might.",
    "Stay awhile. There's more to discover in this zone."
  ]),

  ada: Object.freeze([
    "The forest grows thicker here. You've found the AI & ML Woods.",
    "I'm Ada. I study the patterns that emerge from data.",
    "Twitter Sentiment Analysis—you've learned to read human emotion through text.",
    "And published research. That's rare. Most developers don't bridge that gap.",
    "TensorFlow awaits you. Neural networks. The deeper mysteries of pattern recognition.",
    "The forest reveals itself to those who ask the right questions of their data.",
    "Continue exploring. The summit awaits those who are ready."
  ]),

  mobilearch: Object.freeze([
    "Welcome to Mobile Valley. Where apps meet the real world.",
    "GMMX. A gym management app. Clean, functional, built with Flutter.",
    "Mobile is the future. Everyone carries a computer now.",
    "You understand cross-platform development. Firebase, real-time data, user experience.",
    "Not many developers see the value in mobile work. You do.",
    "The monument you see here marks your entry into a modern world.",
    "There's more to explore. Return when you're ready."
  ]),

  futureyou: Object.freeze([
    "You've made it far. Do you recognize this face?",
    "I'm you. The you that you'll become.",
    "You've walked through all the zones. Learned across domains.",
    "Full-stack development. Data science. Mobile apps. Few developers master all three.",
    "The summit shows where the light from all clearings converges.",
    "Your journey is just beginning. The forest is vast.",
    "But now you know you can walk it."
  ])
});

export default Tier1Dialogues;
